import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface PinAltIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const PinAltIcon = ({ className, ...props }: PinAltIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 10C20 14.4183 12 22 12 22C12 22 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default PinAltIcon;
